import {css} from "@panda/css";

import {Image} from "@pg-design/image-module";
import {Loader} from "@pg-design/loader-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Highlight, Text} from "@pg-design/text-module";
import {priceFormat} from "@pg-mono/string-utils";
import {Currency} from "@pg-rp/common-types";

import {PropertyFlatType} from "../../offer/types/PropertyFlatType";
import {getPriceLabel} from "../../offer/utils/get_price_label";

interface IProps {
    vendorLogo?: string | null;
    vendorName?: string;
    price?: number | null;
    currency?: Currency;
    isDataFetched: boolean;
    shouldShowPrice: boolean;
    offerType?: number;
    flatType?: PropertyFlatType;
    isHolidayLocation?: boolean;
    isCondoHotel?: boolean;
}

export const ApplicationBoxHeading = (props: IProps) => {
    const currencyUnit = props.currency === Currency.EURO ? "eur" : "zł";
    return (
        <div className={header}>
            {props.vendorLogo && (
                <Image className={imageHolder} width="78px" height="58px" alt={`Logo dewelopera: ${props.vendorName || ""}`} src={props.vendorLogo} />
            )}
            <div className={textHolder}>
                {!props.isDataFetched ? (
                    <Loader size="sm" className={mutedLoader} />
                ) : props.shouldShowPrice && props.price ? (
                    <div className={css({display: "flex", flexDirection: "column"})}>
                        <Text variant="info_txt_2">
                            {getPriceLabel({
                                offerType: props.offerType,
                                flatType: props.flatType,
                                isHolidayLocation: props.isHolidayLocation,
                                isCondoHotel: props.isCondoHotel
                            })}
                            :
                        </Text>

                        <Text variant="headline_4" as="p">
                            <Highlight>{priceFormat(props.price, {unit: currencyUnit})}</Highlight>
                        </Text>
                    </div>
                ) : (
                    <span className={noPriceTextHolder}>
                        <Text variant="body_copy_0" className={noPriceAskForOffer}>
                            Zapytaj o ofertę
                        </Text>
                        <Text variant="body_copy_2" color={getThemeVariable("colors.gray.600")}>
                            {props.vendorName}
                        </Text>
                    </span>
                )}
            </div>
        </div>
    );
};

const header = css({
    display: "flex",
    alignItems: "center",
    m: 1,
    gap: 1
});

const imageHolder = css({
    minWidth: "min-content",
    maxWidth: "78px"
});

const textHolder = css({
    display: "flex",
    justifyContent: "center"
});

const noPriceTextHolder = css({
    pl: "calc(var(--globals-baseUnit) * 2)"
});

const noPriceAskForOffer = css({
    mb: "0.2rem"
});

const mutedLoader = css({
    opacity: 0.5
});
import {css} from "@panda/css";

import {Image} from "@pg-design/image-module";
import {Loader} from "@pg-design/loader-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Highlight, Text} from "@pg-design/text-module";
import {priceFormat} from "@pg-mono/string-utils";
import {Currency} from "@pg-rp/common-types";

import {PropertyFlatType} from "../../offer/types/PropertyFlatType";
import {getPriceLabel} from "../../offer/utils/get_price_label";

interface IProps {
    vendorLogo?: string | null;
    vendorName?: string;
    price?: number | null;
    currency?: Currency;
    isDataFetched: boolean;
    shouldShowPrice: boolean;
    offerType?: number;
    flatType?: PropertyFlatType;
    isHolidayLocation?: boolean;
    isCondoHotel?: boolean;
}

export const ApplicationBoxHeading = (props: IProps) => {
    const currencyUnit = props.currency === Currency.EURO ? "eur" : "zł";
    return (
        <div className={header}>
            {props.vendorLogo && (
                <Image className={imageHolder} width="78px" height="58px" alt={`Logo dewelopera: ${props.vendorName || ""}`} src={props.vendorLogo} />
            )}
            <div className={textHolder}>
                {!props.isDataFetched ? (
                    <Loader size="sm" className={mutedLoader} />
                ) : props.shouldShowPrice && props.price ? (
                    <div className={css({display: "flex", flexDirection: "column"})}>
                        <Text variant="info_txt_2">
                            {getPriceLabel({
                                offerType: props.offerType,
                                flatType: props.flatType,
                                isHolidayLocation: props.isHolidayLocation,
                                isCondoHotel: props.isCondoHotel
                            })}
                            :
                        </Text>

                        <Text variant="headline_4" as="p">
                            <Highlight>{priceFormat(props.price, {unit: currencyUnit})}</Highlight>
                        </Text>
                    </div>
                ) : (
                    <span className={noPriceTextHolder}>
                        <Text variant="body_copy_0" className={noPriceAskForOffer}>
                            Zapytaj o ofertę
                        </Text>
                        <Text variant="body_copy_2" color={getThemeVariable("colors.gray.600")}>
                            {props.vendorName}
                        </Text>
                    </span>
                )}
            </div>
        </div>
    );
};

const header = css({
    display: "flex",
    alignItems: "center",
    m: 1,
    gap: 1
});

const imageHolder = css({
    minWidth: "min-content",
    maxWidth: "78px"
});

const textHolder = css({
    display: "flex",
    justifyContent: "center"
});

const noPriceTextHolder = css({
    pl: "calc(var(--globals-baseUnit) * 2)"
});

const noPriceAskForOffer = css({
    mb: "0.2rem"
});

const mutedLoader = css({
    opacity: 0.5
});
